import React from 'react';
import { shape, string, func, arrayOf, oneOfType, number } from 'prop-types';
import { Trans } from 'react-i18next';

// Import styles
import SettingItem from './SettingItem';
import { SettingsName, List } from './styles';

const Setting = ({ profileName, data, onSelect, selected, minLength = 1 }) => {
	if (data?.length < minLength) return null;

	return (
		<div>
			<SettingsName>
				<Trans i18nKey={profileName} />
			</SettingsName>
			<List>
				{data.map((item) => (
					<SettingItem
						key={item.value}
						item={item}
						onSelect={onSelect}
						selected={selected}
					/>
				))}
			</List>
		</div>
	);
};

Setting.propTypes = {
	profileName: string.isRequired,
	data: arrayOf(
		shape({
			value: oneOfType([string, number]).isRequired,
			name: string.isRequired
		})
	).isRequired,
	onSelect: func.isRequired,
	selected: oneOfType([string, number]).isRequired,
	minLength: number
};

export default Setting;
